import React, { useLayoutEffect, useMemo } from "react";
import { useGenericContext } from "@/context/generic";

const Input = ({ className, index, pkey, type, label, category, triggerOnSelect, options, placeholder, inputRef }) => {
    const context = useGenericContext();
    const { simpleDispatch, state } = context;

    const disabled = useMemo(() => {
        if (index == null) return false;
        return state?.step?.current !== index - 1;
    }, [state?.step?.current])

    useLayoutEffect(() => {
        resize(null, true);
    }, [])

    const onChange = (e) => {
        if (pkey == null) return;
        if (e.target.tagName === "TEXTAREA") {
            resize(e?.target);
        }

        simpleDispatch({
            funnel: {
                [pkey]: e.target.value,
            },
        })
    }

    const resize = (el, force = false) => {
        if (el == null && force) {
            el = document?.getElementById?.(state?.funnel?.[pkey]);
        }

        if (el == null) {
            return;
        }

        // Reset field height
        el.style.height = "inherit";
        el.style.height = (el.scrollHeight + 2) + "px";
    }

    const selectOption = (event, _item, _index) => {
        if (pkey == null) return;
        if (triggerOnSelect) {
            let nextStepEvent = new CustomEvent("nextstep", {
                bubbles: true,
            })
            document.dispatchEvent(nextStepEvent)
        }

        simpleDispatch({
            funnel: {
                [pkey]: {
                    index: _index,
                    ..._item,
                },
            },
        })
    }

    if (type === "string") {
        return (
            <div className={className}>
                { label && <label>{label}</label> }
                <input
                    placeholder={placeholder}
                    value={state?.funnel?.[pkey]}
                    onChange={onChange}
                    ref={inputRef}
                />
            </div>
        );
    }

    if (type === "text") {
        return (
            <div className={className}>
                { label && <label>{label}</label> }
                <textarea
                    id={ state?.funnel?.[pkey] ?? null }
                    placeholder={placeholder}
                    value={state?.funnel?.[pkey]}
                    onChange={onChange}
                    ref={inputRef}
                    disabled={disabled}
                />
            </div>
        );
    }

    if (type === "boolean") {
        return (
            <div className={className}>
                { label && <label>{label}</label> }
                <div className="booleans mt-2">
                    { options.map((item, index) => {
                        return (
                            <button
                                className={ [(state?.funnel?.[pkey]?.index === index ? "checked" : "")].join(" ")}
                                key={index}
                                onClick={(event) => selectOption(event, item, index)}
                            >
                                { item.label }
                            </button>
                        );
                    })}
                </div>
            </div>
        );
    }

    if (type === "dropdown") {
        return (
            <div className={className}>
                { label && <label>{label}</label> }
                <select onChange={onChange}>
                    { options.map((item, index) => {
                        return (
                            <option key={index} value={item.value}>
                                { item.label }
                            </option>
                        );
                    })}
                </select>
            </div>
        );
    }

    return (
        <div>
            Not Implemented
        </div>
    );
};

export default Input;
